import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useAppDispatch } from '../../../app/hooks';
import { initializeTicket } from '../state';
import { PageContainer, PageCard } from '../../common/components';
import { TicketCreateHeader } from '../components/TicketForm/headers';
import { TicketCreateForm } from '../components/TicketForm';

/**
 * TicketCreate - Main page component for creating new support tickets
 * Provides a clean, organized interface with logical section groupings
 */
const TicketCreate: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    // Initialize a new ticket when the component mounts
    dispatch(initializeTicket());
  }, [dispatch]);

  return (
    <PageContainer>
      <Box display="flex" justifyContent="center">
        <PageCard>
          <TicketCreateHeader />
          <TicketCreateForm />
        </PageCard>
      </Box>
    </PageContainer>
  );
};

export default TicketCreate;
